'use client';
var secretlyPrevent = function(event) {
    if (event) {
        event.preventDefault();
        event.defaultPrevented = false;
    }
};

export { secretlyPrevent };
